import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxOfferFlagIcon: React.FC<IconSvgProps> = (props) => (
  <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.208 2.60938C18.9301 4.48933 18.5524 6.35304 18.0723 8.19141C17.9687 8.57252 18.0837 8.98267 18.376 9.25391C19.536 10.3315 20.8297 11.2505 22.2227 11.9922C20.3373 14.2275 17.8062 14.0731 14.8193 13.7725C12.274 13.5163 9.34174 13.1359 6.96387 14.8906L4.26758 5.12207C6.17842 3.36733 8.65922 3.62723 11.5547 3.91895C14.0747 4.17283 16.9157 4.4428 19.208 2.60938Z"
      stroke={props.color}
      strokeWidth="1.4"
    />
    <rect
      width="1.37735"
      height="17.624"
      rx="0.688677"
      transform="matrix(-0.96025 0.279143 -0.273051 -0.962 7.13477 22.6157)"
      fill={props.color}
    />
  </svg>
)
